module.exports = __webpack_public_path__ + "static/media/logo.f74b0d26.png";